// extracted by mini-css-extract-plugin
export default {"title":"Sp5Yuglcw53DPyg_qDPc","description":"Rtk_6Oyp45Wdx3Rap650"};